import { useNavigate } from "react-router-dom";
import List from "./components/list/list";
import CreateBtn from "../../components/create-btn/create-btn";
import PageTitle from "../../components/page-title/page-title";
import PermissionGuard from "../../hoc/permission-guard/permission-guard";
import Search from "../../components/search/search";
import { UseTrademarkAPI } from "../../services/use-trademark";
import Params from "../../helpers/params";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import styles from "./styles.module.scss";

const UseTrademark = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { offset } = useSelector((state) => state.pagination);
  const { control, handleSubmit, getValues } = useForm({
    defaultValues: {
      search: "",
    },
  });
  const searchValue = getValues("search");
  const navigateToCreate = () => {
    navigate("create");
  };

  const handleSearch = handleSubmit(async (data) => {
    try {
      const params = { ...Params(), ...data };
      await dispatch(UseTrademarkAPI.getAll(params)).unwrap();
    } catch (error) {
      console.error(error.message);
    }
  });

  return (
    <>
      <PageTitle title="Ապրանքային նշանի օգտագործում" />
      <div className={styles.top_block}>
        <PermissionGuard>
          <CreateBtn onClick={navigateToCreate} text="Ավելացնել" />
        </PermissionGuard>
        <Search
          name="search"
          control={control}
          onSearch={handleSearch}
          className={styles.search}
        />
      </div>
      <List offset={offset} searchValue={searchValue} />
    </>
  );
};

export default UseTrademark;
